import React from "react";
import BoardTypeFilter from "./BoardTypeFilter";
import CategoryFilter from "./CategoryFilter";
import OfferFilter from "./OfferFilter";
import RatingCountFilter from "./RatingCountFilter";
import RoomTypeFilter from "./RoomTypeFilter";
import RoomViewFilter from "./RoomViewFilter";
import TouroperatorsFilter from "./TouroperatorsFilter";
import TravelFilter from "./TravelFilter";
import PriceFilter from "./PriceFilter";
import AirlineFilter from "./AirlineFilter";
import AirportsFilter from "./AirportsFilter";
import TravelTimesFilter from "./TravelTimesFilter";
import AllTouroperatorsFilter from "./AllTouroperatorsFilter";

import { useSelector, useDispatch } from "react-redux";

import HotelAttributeFilter from "./HotelAttributeFilter";
import { views } from "../utils";
import RecommendationFilter from "./RecommendationFilter";
import MarketingActionsFilter from "./MarketingActionsFilter";
import { resetFilter } from "amadeusredux/lib/searchSlice";
import RoomAttributeFilter from "./RoomAttributeFilter";

export default function FilterFrame(props) {
  const {
    changeFilterAndSearch,
    changeClientFilter,

    clientFilters,
    minPrice,
    maxPrice,

    tourOperators,
  } = props;
  const dispatch = useDispatch();
  const view = useSelector((state) => state.system.view);
  const holidayType = useSelector((state) => state.search.holidayType);
  const sidebar = useSelector((state) => state.system.sidebar);

  const roomAttributesFilter = useSelector(
    (state) => state.filter.roomAttributesFilter
  );

  let { offersRoomAttributesAfterFilter, offersRoomAttributes } =
    roomAttributesFilter;

  if (!offersRoomAttributesAfterFilter) {
    offersRoomAttributesAfterFilter = {};
  }

  if (!offersRoomAttributes) {
    offersRoomAttributes = {};
  }

  //if (!sidebar) return <></>;
  return (
    <>
      <div>
        <button
          className="filterbutton"
          style={{ marginLeft: 0, marginTop: 16 }}
          onClick={() => {
            dispatch(resetFilter(view));
            changeFilterAndSearch("dummy", 1);
            /*dispatch(setSaveSearch(true));
                  dispatch(setSidebar(false));
                  if (selectedDestination.length > 0) {
                    if (selectedDestination[0].HotelID) {
                      dispatch(setOutbounddate(""));
                      dispatch(setInbounddate(""));
                      dispatch(setSelectedHotel(selectedDestination[0]));
                      search(dispatch, true, false);
                    } else {
                      dispatch(setOutbounddate(""));
                      dispatch(setInbounddate(""));
                      search(dispatch, false, false);
                      dispatch(setView(views.offerview));
                    }
                  }
                  dispatch(setSaveSearch(false));*/
          }}
        >
          <div style={{ margin: "auto" }}>Filter löschen</div>
        </button>
      </div>{" "}
      {(view === views.offerview ||
        view === views.hotelclassicview ||
        view === views.hotelcrossview) && (
        <PriceFilter
          minPrice={minPrice}
          maxPrice={maxPrice}
          changeFilterAndSearch={changeFilterAndSearch}
        />
      )}
      {view === views.offerview && (
        <CategoryFilter changeFilterAndSearch={changeFilterAndSearch} />
      )}
      {view === views.offerview && (
        <RecommendationFilter changeFilterAndSearch={changeFilterAndSearch} />
      )}
      {view === views.offerview && (
        <RatingCountFilter changeFilterAndSearch={changeFilterAndSearch} />
      )}
      {view === views.offerview && (
        <HotelAttributeFilter
          changeFilterAndSearch={changeFilterAndSearch}
          mostwanted={true}
          changeClientFilter={changeClientFilter}
        />
      )}
      {(view === views.offerview ||
        view === views.hotelclassicview ||
        view === views.hotelcrossview) && (
        <MarketingActionsFilter
          changeFilterAndSearch={changeFilterAndSearch}
          changeClientFilter={changeClientFilter}
        />
      )}
      {(view === views.offerview ||
        view === views.hotelcrossview ||
        view === views.hotelclassicview) && (
        <OfferFilter
          changeFilterAndSearch={changeFilterAndSearch}
          changeClientFilter={changeClientFilter}
        />
      )}
      {(view === views.offerview ||
        view === views.hotelcrossview ||
        view === views.hotelclassicview) && (
        <TravelFilter changeFilterAndSearch={changeFilterAndSearch} />
      )}
      {(view === views.offerview ||
        view === views.hotelcrossview ||
        view === views.hotelclassicview) &&
        holidayType.flight && (
          <TravelTimesFilter changeFilterAndSearch={changeFilterAndSearch} />
        )}
      {(view === views.offerview ||
        view === views.hotelclassicview ||
        view === views.hotelcrossview) &&
        holidayType.flight && (
          <AirportsFilter changeFilterAndSearch={changeFilterAndSearch} />
        )}
      {(view === views.offerview ||
        view === views.hotelclassicview ||
        view === views.hotelcrossview) &&
        holidayType.flight && (
          <AirlineFilter changeFilterAndSearch={changeFilterAndSearch} />
        )}
      {(view === views.offerview ||
        view === views.hotelclassicview ||
        view === views.hotelcrossview) && (
        <BoardTypeFilter changeFilterAndSearch={changeFilterAndSearch} />
      )}
      {(view === views.offerview ||
        view === views.hotelclassicview ||
        view === views.hotelcrossview) && (
        <RoomTypeFilter
          changeFilterAndSearch={changeFilterAndSearch}
          changeClientFilter={changeClientFilter}
        />
      )}
      {(view === views.hotelclassicview || view === views.hotelcrossview) &&
        Object.keys(offersRoomAttributes).length > 0 && (
          <RoomAttributeFilter changeFilterAndSearch={changeFilterAndSearch} />
        )}
      {(view === views.offerview ||
        view === views.hotelclassicview ||
        view === views.hotelcrossview) && (
        <RoomViewFilter changeFilterAndSearch={changeFilterAndSearch} />
      )}
      {(view === views.offerview ||
        view === views.hotelclassicview ||
        view === views.hotelcrossview) && (
        <AllTouroperatorsFilter changeFilterAndSearch={changeFilterAndSearch} />
      )}
      {view === views.offerview && (
        <HotelAttributeFilter
          changeFilterAndSearch={changeFilterAndSearch}
          mostwanted={false}
        />
      )}
    </>
  );
}
